import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardSubtitle, Form, Container, Button, Alert } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from "../../helpers/url_helper"

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const ApprovePDP = () => {
        const history = useHistory();
        const {no,id} = useParams();

        const [userError, setUserError] = useState('');
        const [isloading, setIsloading] = useState(false);
        const [isLoading, setIsLoading] = useState(false);
        const [showApproveBtn, setShowApproveBtn] = useState(true);
        const [showRejectBtn, setShowRejectBtn] = useState(false);

        const [details, setDetails] = useState(null)
        const [skills, setSkills] = useState([])
 

        useEffect(() => {
            setIsloading(true)
            axios.get(url.PDP + "?$filter=No eq '"+ no +"' &$expand=personalDevtPlanLines", HRConfig)
                .then(function(response){
                    if(response.data.value.length > 0){
                        toastr.success("Personal Development Plan Details Found");
                        setUserError(false);
                        setDetails(response.data.value[0])
                    }else{
                        toastr.error("Leave Plan Details Not Found");
                    }
                    setIsloading(false)
                }).catch(function (error) {
                    setUserError(true);
                    setIsloading(false)
                })
                .then(function () {
                // always executed
            });
        
        },[]);

        const handleActionChange = () => {
            const selectedAction = document.getElementsByClassName('lAction')[0].value;
            if(selectedAction == 'APPROVE'){
                setShowApproveBtn(true)
                setShowRejectBtn(false)
            }else if(selectedAction == 'REJECT'){
                setShowApproveBtn(false)
                setShowRejectBtn(true)
            }
        }



        const [inputs, setInputs] = useState([]);
        toastr.options = TOAST_OPTIONS;
  
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const handleSubmit = (event) => {
            event.preventDefault();

        }  
 
        const handleApprovePlan = () => {
            setIsloading(true)
            const lNo = {'no': details.No}
            axios.post(url.APPROVEPR, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("Leave Plan Approved" );
                        history.push(`/approved/${details.No}`) 
                    }else{
                        toastr.success("Could not Approve" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    //console.log(error.response.data.error.message)
                })
                .then(function (r) {
                // always executed
                setIsloading(false)
            });
        }   
        const handleReject = () =>{
            //console.log(REJECT_LR )
        }   
        

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                {details && (
                <div className="page-content">
                    <MetaTags>
                    <title>Approve {details.No} | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem={`Approve ${details.No} `} />
                        <Form onSubmit={handleSubmit}>
                        <Alert color={(details.Status == 'Approved') ? `success` : (details.Status == 'Pending Approval') ? `warning` : `danger`} role="alert">
                                {details.Status}      
                        </Alert>
                     
                       
                        <Row>
                        
                            <Col  xl={12}>
                            <Card>
                                <CardBody>
                           
                           
                 
                                
                               
                               
                                           
                                <Row>
                                  <Col lg={12}>
                                    {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                                  </Col>
                          
                                    {details && (
                                        <>
                                    
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeNo' id="EmployeeNo" type="text" className="form-control" disabled={true}  defaultValue = {details.No +"/ "+ details.Status } />
                                            <label htmlFor="floatingIdInput">No/Status</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeNo' id="EmployeeNo" type="text" className="form-control" disabled={true}  defaultValue = {details.EmployeeNo} />
                                            <label htmlFor="floatingIdInput">Employee No</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeName' id="EmployeeName"  type="text" className="form-control" disabled={true} defaultValue={details.EmployeeName} />
                                            <label htmlFor="floatingnameInput">Employee Name</label>
                                            </div>
                                        </Col>
                                      
                                
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='Title' id="Title"  type="text" className="form-control" disabled={true} defaultValue={details.PositionName} />
                                            <label htmlFor="floatingDepartInput">Title</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-1">
                                            <input name='EmployeeName' id="EmployeeName"  type="text" className="form-control" disabled={true} defaultValue={details.HRMDocumentType} />
                                            <label htmlFor="floatingnameInput">Document Name</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-1">
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    defaultDate: new Date(details.PostingDate) 
                                                }}
                                                onChange={(d)=>{setPostingDate(d)}}
                                                />
                                            <label htmlFor="floatingDepartInput">Posting Date</label>
                                            </div>
                                        </Col>
                                        <Col  xl={12}>
                       
                                
                       <div>
                               {(details.personalDevtPlanLines).map((formRow, key) => (
                           <span key={key}>
        
                           <strong className='mb-2'>Development Plan Line {key+1}</strong> 
                                   <Row >
                                   
                               
               
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating mb-3">
                                       <input type="text" className='form-control devtGoal' defaultValue={formRow.DevtGoalsfortheyear} /> 
                                       <label htmlFor="floatingSelectGrid">Development Goal for the Year</label>
                                   </div>
                                   </Col>
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating mb-3">
                                       <input type="text" className='form-control trainingDevtGoal' defaultValue={formRow.TrainingandDevtGoal} />
                                       <label htmlFor="floatingSelectGrid">Training and Development Goal</label>
                                   </div>
                                   </Col>
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating ">
                                       <select className='form-select skillToAcquire' defaultValue={formRow.SkillCode}  >{skills.map((s,k)=>(<option key={k} value={s.Code}>{s.Description}</option>))}</select>
                                       <label htmlFor="floatingSelectGrid">Skill to be Acquired</label>
                                   </div>
                                   </Col>
                                   
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating">
                                       <input type="text" className='form-control actionStep' defaultValue={formRow.EmployeeActionSteps} />
                                       <label htmlFor="floatingSelectGrid">Employee Action Step</label>
                                   </div>
                                   </Col>
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating">
                                       <input type="text" className='form-control resourcesNeeded' defaultValue={formRow.ResourcesNeeded} />
                                       <label htmlFor="floatingSelectGrid">Resources Needed</label>
                                   </div>
                                   </Col>

                                   <Col lg={4} className="mb-3">
                                       <div className="form-floating mb-3">
                                       <Flatpickr
                                           className="form-control lDates"
                                           placeholder="dd M,yyyy"
                                           options={{
                                               mode: "range",
                                               dateFormat: "Y-m-d",
                                               defaultDate: [new Date(formRow.StartDate), new Date(formRow.EndDate)] 
                                           }}
                                           />
                                       <label htmlFor="floatingPlanningDateInput">Start Date - End Date</label>
                                       </div>
                                   </Col>
                                   
                                   </Row>
                                  </span>
                               ))}

                                   </div>
     
                                </Col>
                                        </>
                                    )}
                                    
                                  </Row> 
                                  <Row>
                                                <Col md={12}>
                                                    <div className="form-floating mb-3">
                                                        <select  className="form-select lAction" onChange={handleActionChange}>
                                                            
                                                            <option value="APPROVE">APPROVE</option>
                                                            <option value="REJECT">REJECT</option>
                                    
                                                        </select>
                                                        <label htmlFor="floatingSelectGrid"> Select Action</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {showRejectBtn && (
                                                <Row>
                                                <Col md={12}>
                                                    <div className="form-floating mb-3">
                                                        <input name='rejectComment'  type="text" className="form-control rejectComment"  onChange={handleChange}   />
                                                        <label htmlFor="floatingSelectGrid"> Rejection Comment</label>
                                                    </div>
                                                </Col>
                                                </Row>
                                            )}
                                            </CardBody>
                                            </Card>
                                            
                                       
                  
                                                    {showRejectBtn && (
                                                    <Col md={12} className="reject">
                                                        <div className="d-grid gap-2">
                                                            <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleReject}>
                                                                Reject
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                    )}
                                                    {showApproveBtn && (
                                                    <Col md={12} className="approve">
                                                        <div className="d-grid gap-2">
                                                            <Button color="success" type="button" className="btn btnApproveRequest" onClick={handleApprovePlan}>
                                                            Approve 
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                    )}
                                             
                                            
                    
                        </Col>
                        </Row>
                        </Form>


                    </Container>
                </div>
                )}
                </LoadingOverlay>
            </>
        );
    }

export default ApprovePDP;